import {Prissoknad} from "../../api/prissoknader"
import React from "react"
import styles from "./styles.module.scss"
import {classes} from "../../utils/utils"
import {IPktTag, PktTag} from "@oslokommune/punkt-react"
import PrissoknadStatus from "../../components/Prissoknad";

const soknadStatusText = Object.freeze({
    VENTER_PÅ_SKATTEOPPGJØR: 'Mottatt',
    OVERSENDT_SAKSBEHANDLER: 'Under behandling',
    FERDIGBEHANDLET: 'Ferdig behandlet',
    SKAL_IKKE_BEHANDLES: 'Stoppet'
})

const soknadStatusColor: { [id: string]: IPktTag['skin']; } = Object.freeze({
    VENTER_PÅ_SKATTEOPPGJØR: 'blue',
    OVERSENDT_SAKSBEHANDLER: 'beige',
    FERDIGBEHANDLET: 'green',
    SKAL_IKKE_BEHANDLES: 'grey'
})

type PrissoknadListItemProps = {
    prissoknad: Prissoknad,
}

const PrissoknadListItem = ({prissoknad}: PrissoknadListItemProps) => {
    const soknadDate = prissoknad.innsendtdato && new Date(prissoknad.innsendtdato).toLocaleString("no-NB", {dateStyle: "short"})

    return (
        <div className={styles.soknadListRowContainer}>
            <div className={classes(styles.soknadListRow, styles.columnText)}>
                <span className={classes(styles.flexColumn)}>{soknadDate}</span>
                <span className={classes(styles.flexColumn)}>Redusert barnehagepris</span>
                <span className={classes(styles.flexColumn)}>
                {prissoknad.søknadstype === "RESØKNAD" ? 'Oslo kommune' : prissoknad.hovedsøkerFulltNavn}
            </span>
                <span className={classes(styles.flexColumn, styles.includeOnLargeScreen)}>
                <PktTag skin={soknadStatusColor[prissoknad.søknadsstatus]}>
                    {soknadStatusText[prissoknad.søknadsstatus as keyof typeof soknadStatusText]}
                </PktTag>
            </span>
            </div>
            <div>
                <PrissoknadStatus prissoknad={prissoknad} className="px-size-16 pb-size-16 mt-size-16"/>
            </div>
        </div>
    )
}

export default PrissoknadListItem
